module.exports = __webpack_public_path__ + "assets/img/snapshutdown_cn.6ddebaa2.png";